import { render, staticRenderFns } from "./dr-expansion-panel-editor.vue?vue&type=template&id=2d84e719&"
import script from "./dr-expansion-panel-editor.vue?vue&type=script&lang=js&"
export * from "./dr-expansion-panel-editor.vue?vue&type=script&lang=js&"
import style0 from "./dr-expansion-panel-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports